(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["cart-discount-code"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.cartDiscountBound) return;
    window.cartDiscountBound = true;

    function updateDiscount(element, code) {
      var root = element.closest('[data-cart-root]');
      var sectionId = root && root.dataset.sectionId;
      if (root) root.querySelectorAll('.cart__totals').forEach(function (el) { el.classList.add('is-loading'); });

      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: code, sections: sectionId })
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          var sectionHtml = cart.sections && cart.sections[sectionId];
          if (!root || !sectionHtml) return;

          var doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
          var fresh = doc.querySelector('[data-cart-root]');
          if (fresh) root.innerHTML = fresh.innerHTML;
        })
        .catch(function (error) {
          console.error('Discount code update failed', error);
          if (root) root.querySelectorAll('.cart__totals').forEach(function (el) { el.classList.remove('is-loading'); });
        });
    }

    document.addEventListener('submit', function (event) {
      var form = event.target.closest('[data-cart-discount-form]');
      if (!form) return;
      event.preventDefault();

      var code = form.querySelector('[data-cart-discount-input]').value.trim();
      if (code) updateDiscount(form, code);
    });

    document.addEventListener('click', function (event) {
      var removeButton = event.target.closest('[data-cart-discount-remove]');
      if (removeButton) updateDiscount(removeButton, '');
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["cart-referral-code"] && !Shopify.designMode) return;
  try {
    function initCartReferralForm(scope) {
    scope.querySelectorAll('[data-cart-referral-form]').forEach(function (form) {
      if (form.dataset.referralBound) return;
      form.dataset.referralBound = 'true';

      form.addEventListener('submit', function (event) {
        event.preventDefault();

        var input = form.querySelector('[data-cart-referral-input]');
        var attributeName = form.dataset.attributeName;
        if (!attributeName) return;

        var attributes = {};
        attributes[attributeName] = input.value.trim();

        fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: attributes })
        }).catch(function (error) {
          console.error('Cart attribute update failed', error);
        });
      });
    });
  }

  initCartReferralForm(document);

  document.addEventListener('shopify:section:load', function (event) {
    initCartReferralForm(event.target);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["dealer-map"] && !Shopify.designMode) return;
  try {
    function loadMapLibre(callback) {
    if (window.maplibregl) {
      callback();
      return;
    }

    if (!window.__maplibreLoading) {
      window.__maplibreLoading = new Promise(function (resolve) {
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = 'https://cdn.jsdelivr.net/npm/maplibre-gl@5.24.0/dist/maplibre-gl.css';
        document.head.appendChild(link);

        var script = document.createElement('script');
        script.src = 'https://cdn.jsdelivr.net/npm/maplibre-gl@5.24.0/dist/maplibre-gl.js';
        script.onload = function () {
          resolve();
        };
        document.head.appendChild(script);
      });
    }

    window.__maplibreLoading.then(callback);
  }

  function initDealerMap(root) {
    var canvas = root.querySelector('[data-dealer-map-canvas]');
    if (!canvas || canvas.dataset.initialized) return;
    canvas.dataset.initialized = 'true';

    var map = new maplibregl.Map({
      container: canvas,
      style: 'https://tiles.openfreemap.org/styles/positron',
      center: [2.4, 46.6],
      zoom: 4.5,
      scrollZoom: false,
      attributionControl: { compact: true }
    });

    map.addControl(new maplibregl.NavigationControl({ showCompass: false }), 'top-right');

    var bounds = new maplibregl.LngLatBounds();
    var count = 0;

    root.querySelectorAll('[data-garage]').forEach(function (el) {
      var lat = parseFloat(el.dataset.lat);
      var lng = parseFloat(el.dataset.lng);
      if (isNaN(lat) || isNaN(lng)) return;

      var icon = document.createElement('img');
      icon.src = root.dataset.iconUrl;
      icon.alt = '';
      icon.className = 'dealer-map__pin';

      var marker = new maplibregl.Marker({ element: icon, anchor: 'bottom' }).setLngLat([lng, lat]).addTo(map);
      var name = el.dataset.name;
      var address = el.dataset.address;

      if (name || address) {
        var popup = document.createElement('div');

        if (name) {
          var title = document.createElement('p');
          title.className = 'garage-popup__name';
          title.textContent = name;
          popup.appendChild(title);
        }

        if (address) {
          var addr = document.createElement('p');
          addr.className = 'garage-popup__address';
          addr.textContent = address;
          popup.appendChild(addr);
        }

        marker.setPopup(new maplibregl.Popup({ offset: 32 }).setDOMContent(popup));
      }

      bounds.extend([lng, lat]);
      count++;
    });

    if (count > 1) {
      map.fitBounds(bounds, { padding: 48, animate: false });
    } else if (count === 1) {
      map.jumpTo({ center: bounds.getCenter(), zoom: 12 });
    }
  }

  function initAllDealerMaps(scope) {
    scope.querySelectorAll('[data-dealer-map]').forEach(function (root) {
      loadMapLibre(function () {
        initDealerMap(root);
      });
    });
  }

  initAllDealerMaps(document);

  document.addEventListener('shopify:section:load', function (event) {
    initAllDealerMaps(event.target);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["featured-row"] && !Shopify.designMode) return;
  try {
    function initFeaturedRowTrack(track) {
    if (track.dataset.duplicated) return;
    track.dataset.duplicated = 'true';

    Array.from(track.children).forEach(function (child) {
      var clone = child.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
    });
  }

  document.querySelectorAll('.featured-row--autoscroll [data-featured-row-track]').forEach(initFeaturedRowTrack);

  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('.featured-row--autoscroll [data-featured-row-track]').forEach(initFeaturedRowTrack);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["hotspot"] && !Shopify.designMode) return;
  try {
    function resetHotspotPanelMotion(panel) {
    panel.classList.remove('is-nav-swap', 'is-nav-entering');
  }

  function setActiveHotspot(panel) {
    var button = panel && panel.previousElementSibling;

    document.querySelectorAll('.hotspot.is-active').forEach(function (activeButton) {
      if (activeButton !== button) activeButton.classList.remove('is-active');
    });

    if (button && button.classList.contains('hotspot')) {
      button.classList.add('is-active');
    }
  }

  function bindHotspotPanelClose(panel) {
    if (panel.dataset.closeBound) return;
    panel.dataset.closeBound = 'true';

    panel.addEventListener('close', function () {
      var button = panel.previousElementSibling;
      if (button && button.classList.contains('hotspot')) {
        button.classList.remove('is-active');
      }
    });
  }

  document.querySelectorAll('dialog.hotspot-panel').forEach(bindHotspotPanelClose);

  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('dialog.hotspot-panel').forEach(bindHotspotPanelClose);
  });

  function openHotspotPanel(panel, navSwap) {
    if (!panel || panel.tagName !== 'DIALOG') return;

    document.querySelectorAll('dialog.hotspot-panel[open]').forEach(function (openPanel) {
      if (openPanel !== panel) {
        resetHotspotPanelMotion(openPanel);
        openPanel.close();
      }
    });

    resetHotspotPanelMotion(panel);
    setActiveHotspot(panel);

    if (navSwap) {
      panel.classList.add('is-nav-swap', 'is-nav-entering');
      panel.addEventListener(
        'animationend',
        function handler() {
          panel.classList.remove('is-nav-entering');
          panel.removeEventListener('animationend', handler);
        },
        { once: true }
      );

      panel.showModal();
      return;
    }

    panel.showModal();
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('.hotspot');

    if (trigger) {
      var targetPanel = trigger.nextElementSibling;
      var openPanel = document.querySelector('dialog.hotspot-panel[open]');

      if (openPanel && openPanel !== targetPanel) {
        openPanel.classList.add('is-nav-swap');
        openPanel.close();
        openHotspotPanel(targetPanel, true);
      } else {
        openHotspotPanel(targetPanel);
      }

      return;
    }

    var closeButton = event.target.closest('.hotspot-panel__close');

    if (closeButton) {
      var dialog = closeButton.closest('dialog');
      if (dialog) dialog.close();
      return;
    }

    var navButton = event.target.closest('[data-hotspot-nav]');

    if (navButton) {
      var currentDialog = navButton.closest('dialog.hotspot-panel');
      if (!currentDialog) return;

      var scope =
        currentDialog.closest('[data-hotspot-scope]') ||
        currentDialog.closest('.shopify-section') ||
        document;
      var panels = Array.from(scope.querySelectorAll('dialog.hotspot-panel'));
      var index = panels.indexOf(currentDialog);
      var direction = navButton.getAttribute('data-hotspot-nav') === 'next' ? 1 : -1;
      var nextIndex = (index + direction + panels.length) % panels.length;
      var nextPanel = panels[nextIndex];

      if (nextPanel === currentDialog) return;

      currentDialog.classList.add('is-nav-swap');
      currentDialog.close();

      openHotspotPanel(nextPanel, true);
    }
  });

  document.addEventListener('click', function (event) {
    if (event.target.tagName !== 'DIALOG' || !event.target.classList.contains('hotspot-panel')) {
      return;
    }

    var rect = event.target.getBoundingClientRect();
    var inside =
      rect.top <= event.clientY &&
      event.clientY <= rect.top + rect.height &&
      rect.left <= event.clientX &&
      event.clientX <= rect.left + rect.width;

    if (!inside) {
      event.target.close();
    }
  });
  } catch(e) { console.error(e); }
})();

})();
